import Component from '@ux/component';
import React from 'react';
import PropTypes from 'prop-types';

/**
 * Display content of each Tab. The Tabs component can optionally use TabContent.
 *
 * @class TabContent
 * @displayName Tab Content
 * @public
 */
export default class TabContent extends Component {
  /**
   * Render the TabContent Component. The TabContent is only rendered if the current
   * selected tab matches the index of the TabContent.
   *
   * @returns {React.DOM} div element with children
   * @private
   */

  render() {
    return (
      <div { ...this.props }  role='tabpanel' />
    );
  }
}

/**
 * Property validation
 *
 * @type {Object}
 * @api private
 */
TabContent.propTypes = {
  /** Classes to be applied to tab content */
  className: PropTypes.string,
  /** Contents of the tab */
  children: PropTypes.node
};
